import React, { useCallback, useEffect, useState } from "react";
import {
  CircularAvatar,
  ErrorSuccessModal,
  RadioContainer,
} from "../../../commons";
import Select from "react-select";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllFinacManagerAction,
  resetAuthError,
  resetFinacManagerList,
  resetSession,
} from "../../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../../commonTypes/authTypes";
import { connect } from "react-redux";
import { components } from "react-select";
import useDebounce from "../../../../customHooks/useDebounce";
import { SCHEDULING_ESTIMATE_JOB_OPTIONS } from "../../../../constant/scheduling";
import OneTimeEstimate from "./OneTimeEstimate";
import DailyEstimate from "./DailyEstimate";
import {
  AddSchedulingEstimateAction,
  getSchedulingBandWidthAction,
  getSchedulingUserViewListAction,
  resetDailyHours,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
  resetSchedulingUserViewListing,
} from "../../../../redux/scheduling";
import { Col, Label, Row } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-hot-toast";
import { CalenderIcon } from "../../../Icon";
import {
  formatDate,
  handleDate,
  reverseDate,
} from "../../../../utils/commonFunctions";
import { Toaster } from "react-hot-toast";
import ConfirmationModalScheduling from "../ConfirmationModalScheduling";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
export const oneTimeEstimateDataInput: any[] = [
  {
    date: "",
    hours: "",
    progressCount: 0,
    previoushours: ""
  },
];
type AppProps = {
  finacManagerList: any;
  dispatchGetAllFinacManagerAction: (data: any) => void;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  dispatchResetFinacManagerList: () => void;
  dispatchGetSchedulingBandWidthAction: (data: any) => void;
  dispatchGetSchedulingUserViewDataAction: (data: any) => void;
  dispatchResetSchedulingUserList: (data: any) => void;
  managerFetching: boolean;
  previousHours: any;
  showSchedulingEstimateData: any;
  dispatchResetDailyHours: () => void;
  token: string | null;
  totalManagerCount: string | number;
  selectedClient: any;
  setShowSchedulingEstimateModal: any;
  dailyHours: any;
  showSchedulingEstimateModal: any;
  estimatedJobFunction: any;
  dispatchResetUserViewSuccess: () => void;
  dispatchResetUserViewError: () => void;
  dispatchResetUserViewMessage: () => void;
  dispatchResetUserViewStatusCode: () => void;
  dispatchResetAuthError: () => void;
  fetching: boolean;
  success: number | null;
  error: null | string;
  statusCode: number | null;
  message: string | null;
  dispatchResetSession: () => void;
  reEstimateDataList: any;
  sendForApproval?: any;
  handleupdateAction?: (data: string, action: string) => void;
  update?: string | undefined;
  loginData: LoginResponseType;
  onClose: () => void;
  manager: any;
  setManager: any;
  dateRange: any;
  setDateRange: any;
  jobData: any;
  setJobData: any;
  sendApproval: any;
  setSendApproval: any;
  oneTimeEstimateData: any;
  setOneTimeEstimateData: any;
  handleAddEstimateData: () => void;
  startDate: any;
  setStartDate: (data: any) => void;
  endDate: any;
  setEndDate: (data: any) => void;
  setDisable: (data: boolean) => void;
};
const JobEstimateTab = ({
  finacManagerList,
  dailyHours,
  dispatchResetSession,
  previousHours,
  dispatchGetAllFinacManagerAction,
  dispatchResetDailyHours,
  managerFetching,
  dispatchGetSchedulingBandWidthAction,
  token,
  selectedClient,
  totalManagerCount,
  showSchedulingEstimateData,
  dispatchResetUserViewSuccess,
  dispatchResetUserViewError,
  dispatchResetUserViewMessage,
  dispatchResetUserViewStatusCode,
  dispatchResetAuthError,
  fetching,
  reEstimateDataList,
  success,
  update,
  loginData,
  onClose,
  manager,
  setManager,
  dateRange,
  setDateRange,
  jobData,
  setJobData,
  sendApproval,
  setSendApproval,
  oneTimeEstimateData,
  setOneTimeEstimateData,
  handleAddEstimateData,
  startDate,
  setStartDate,
  endDate,
  error,
  statusCode,
  setEndDate,
  setDisable
}: AppProps) => {

  const [finalManagerList, setFinalManagerList] = useState<any>([]);

  const [dateArray, setDateArray] = useState<any>([]);
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [managerText, setManagerText] = useState<string>("");
  const [getRestimateHours, setGetRestimateHours] = useState<any>([]);
  const [checkInputChange, setInputChange] = useState(true);
  const [dailyTotal, setDailyTotal] = useState<number>(0)
  const [input, setInput] = useState<number | null>(null)
  const [index, setIndex] = useState<number>(0);
  const [disableDate, setDisableDate] = useState<any>([]);
  const [dateErrorMessage, setDateErrorMessage] = useState<any>(null);
  const [persistDateRange, setPersistDateRange] = useState<any>([]);


  useEffect(() => {
    dispatchResetUserViewSuccess();
    dispatchResetUserViewError();
    dispatchResetUserViewMessage();
    dispatchResetUserViewStatusCode();
    dispatchResetDailyHours()
    toast.remove()
  }, []);

  useEffect(() => {
    let result = dateRange.reduce(function (acc: any, obj: any) {

      return (+acc) + (+obj.hours)
    }, 0);
    setDailyTotal(result)
  }, [input, index, dateRange]);


  useEffect(() => {
    setDateErrorMessage(null);
  }, [jobData]);

  useEffect(() => {
    if (oneTimeEstimateData?.length > 0 || dateRange?.length > 0) {
      let todayDate = moment(new Date()).format("YYYY-MM-DD");
      let newData: any = jobData === "oneTime" ? oneTimeEstimateData : dateRange;
      let data: any = newData?.filter((item: any) => {
        let prevDate = item?.date && moment(new Date(item?.date)).format("YYYY-MM-DD");
        return ((!item?.date && !item?.hours) || (jobData === "oneTime" && !item?.hours) || !item?.date || ((reEstimateDataList?.schedule_status == 3 || reEstimateDataList?.schedule_status == 2 || (update && reEstimateDataList?.schedule_status == 1)) ? ((new Date(prevDate?.split("-")?.join(",")) >= new Date(todayDate?.split("-")?.join(","))) && item?.errorMessage) : item?.errorMessage))
      })
      if (oneTimeEstimateData?.length && jobData === "oneTime") {

        let arr: any = [];
        oneTimeEstimateData?.map((item: any) => {
          arr.push(new Date(item?.date))
        })
        setDisableDate([...arr])
      }
      else if (jobData === "daily") {
        setDisableDate([]);
      }

      if (data?.length === 0) {
        setDisable(false)
      }
      else {
        setDisable(true)
      }

    }

  }, [oneTimeEstimateData, dateRange])

  useEffect(() => {
    let newDateRange: any = jobData === "daily" ? JSON.parse(JSON.stringify(dateRange)) : JSON.parse(JSON.stringify(oneTimeEstimateData))
    if (dailyHours && Object.keys(dailyHours)?.length > 1) {

      let finalDateRange: any = newDateRange?.map((item: any) => {

        if (dailyHours[moment(item.date).format("DD-MM-YYYY")]) {
          if (+dailyHours[moment(item.date).format("DD-MM-YYYY")] > 12) {
            return { ...item, previousHours: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], progressCount: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], errorMessage: showSchedulingEstimateData?.schedule_status != 3 ? "Error! Maximum hours for the day exceeded" : "" }
          }
          else if ((item["hours"] > (12 - +dailyHours[moment(item?.date).format("DD-MM-YYYY")]))) {
            return { ...item, previousHours: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], progressCount: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], errorMessage: showSchedulingEstimateData?.schedule_status != 3 ? `Maximum ${(12 - +dailyHours[moment(item?.date).format("DD-MM-YYYY")])} hours remaining for the day` : "" }
          }
          else {

            return { ...item, previousHours: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], progressCount: +dailyHours[moment(item?.date).format("DD-MM-YYYY")], errorMessage: "" }
          }

        }
        return { ...item, previousHours: 0, progressCount: 0, errorMessage: "" }
      })

      if (finalDateRange?.length) {
        setPersistDateRange([...finalDateRange])
        jobData === "daily" ? setDateRange([...finalDateRange]) : setOneTimeEstimateData([...finalDateRange])
        setGetRestimateHours([...finalDateRange])
      }
    }
  }, [dailyHours])

  useEffect(() => {
    if (showSchedulingEstimateData?.schedule_status != 0 && oneTimeEstimateData?.length === 1 && jobData == "oneTime") {
      let newDateRange: any = JSON.parse(JSON.stringify(oneTimeEstimateData))
      newDateRange[0]["progressCount"] = previousHours;

      if (previousHours === 12) {
        newDateRange[0]["errorMessage"] = showSchedulingEstimateData?.schedule_status != 3 ? "Error! Maximum hours for the day exceeded" : ""
      }
      else if ((newDateRange[0]["hours"] > (12 - +dailyHours?.hours))) {
        newDateRange[0]["errorMessage"] = showSchedulingEstimateData?.schedule_status != 3 ? `Maximum ${+(12 - +dailyHours?.hours)?.toFixed(2)} hours remaining for the day` : ""
      }
      else {
        newDateRange[0]["errorMessage"] = ""
      }
      setPersistDateRange([...newDateRange])
      setOneTimeEstimateData([...newDateRange])
      setGetRestimateHours([...newDateRange])
    }

  }, [previousHours, showSchedulingEstimateData])

  useEffect(() => {
    if (reEstimateDataList?._id) {
      setManager({
        value: reEstimateDataList?.manager?.user_id,
        label: `${reEstimateDataList?.manager?.first_name} ${reEstimateDataList?.manager?.last_name}`,
      });
      setDataFunction()
    }
  }, [reEstimateDataList?._id, reEstimateDataList?.schedule_status, reEstimateDataList?.estimation_start_date, reEstimateDataList?.estimation_end_date, reEstimateDataList?.estimate_data]);

  const setDataFunction = (type?: string) => {
    if (reEstimateDataList?.estimation_type === 1) {
      type != "reset" && setJobData("oneTime");
      let arr: any[] = [];
      let dateArr: any = [];
      reEstimateDataList?.estimate_data?.map((item: any) => {
        dateArr.push(item.date)
        arr.push({
          date: item.date ? handleDate(item.date).split("T")[0] : null,
          previoushours: +item.hours,
          hours: +item.hours,
          requestId: reEstimateDataList?.schedule_status == 3 ? item?.request_id : ""
        });
      });
      type != "reset" && setDateArray([...dateArr]);
      setOneTimeEstimateData([...arr]);
      setGetRestimateHours([...arr]);
    }
    else if (reEstimateDataList?.estimation_type === 2) {
      type != "reset" && setJobData("daily");
      setOneTimeEstimateData([]);
      setStartDate(
        new Date(
          moment(
            `${reEstimateDataList?.estimation_start_date}T00:00:00`,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD[T]HH:mm:ss")
        )
      );
      setEndDate(
        new Date(
          moment(
            `${reEstimateDataList?.estimation_end_date}T00:00:00`,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD[T]HH:mm:ss")
        )
      );

      const range = [];
      let date = moment(new Date(
        moment(
          `${reEstimateDataList?.estimation_start_date}T00:00:00`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD[T]HH:mm:ss")
      ));

      while (date <= moment(new Date(
        moment(
          `${reEstimateDataList?.estimation_end_date}T00:00:00`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD[T]HH:mm:ss")
      ))) {
        range.push({ date: date.toDate(), progressCount: 0, hours: 0 });
        date = date.clone().add(1, "day");
      }

      type != "reset" && setDateRange([...range]);
      setGetRestimateHours([...range]);
    }
    else {
      setOneTimeEstimateData([]);
    }
  }


  useEffect(() => {

    if (jobData === "oneTime" && reEstimateDataList?.estimate_data && reEstimateDataList?.estimation_type == 1) {

      let newOneTimeEstimate = JSON.parse(JSON.stringify(getRestimateHours));
      let newData: any = [];
      if (reEstimateDataList?.estimate_data?.length > 0 && (reEstimateDataList?.schedule_status == 3 || reEstimateDataList?.schedule_status == 2 || (update && reEstimateDataList?.schedule_status == 1)) && newOneTimeEstimate?.length > 0 && checkInputChange) {
        newOneTimeEstimate?.map((item: any) => {
          let flag = false;
          let requestedId = "";
          reEstimateDataList?.estimate_data?.map((insideItem: any) => {

            if (moment(insideItem?.date).format("DD-MM-YYYY") == moment(item?.date).format("DD-MM-YYYY")) {
              requestedId = insideItem?.request_id
              return flag = true;
            }
          })
          newData.push({ ...item, hours: +item.hours, previousHours: +item.hours, requestId: (reEstimateDataList?.schedule_status == 3) ? requestedId : "" })
        });



        if (newData?.length) {
          setOneTimeEstimateData([...newData])
        }
      }
    }
    else if (reEstimateDataList?.estimate_data && reEstimateDataList?.estimation_type == 2) {
      const reEstimateData = JSON.parse(JSON.stringify(getRestimateHours))
      let newData: any = [];

      if (reEstimateDataList?.estimate_data?.length > 0 && (reEstimateDataList?.schedule_status == 3 || reEstimateDataList?.schedule_status == 2 || (update && reEstimateDataList?.schedule_status == 1)) && reEstimateData?.length > 0 && checkInputChange) {
        reEstimateData?.map((insideItem: any) => {
          let newArray: any = {}
          reEstimateDataList?.estimate_data?.map((item: any) => {
            if (moment(insideItem?.date).format("DD-MM-YYYY") == moment(item?.date).format("DD-MM-YYYY")) {

              return newArray = { ...insideItem, hours: +item.hours, previousHours: +item.hours, requestId: reEstimateDataList?.schedule_status == 3 ? item?.request_id : "" }
            }
          })
          if (newArray?.date) {
            newData?.push(newArray)
          }
          else {
            newData?.push({ ...insideItem })
          }

        });
        setPersistDateRange([...newData])

        if (newData?.length) {
          setDateRange([...newData])

        }
      }
    }
  }, [getRestimateHours, dailyHours]);

  useEffect(() => {
    getBandWidth()
  }, [dateArray])

  useEffect(() => {

    getBandWidth();


    if (jobData === "oneTime" && reEstimateDataList?.estimation_type != 1) {
      setOneTimeEstimateData([...oneTimeEstimateDataInput])
      setDataFunction("reset")
    }
    if (jobData === "daily" && reEstimateDataList?.estimation_type != 2) {
      setDateRange([])
      setDataFunction("reset")
      setStartDate(null)
      setEndDate(null)
    }


  }, [jobData, reEstimateDataList])


  function getBandWidth() {
    if (dateArray?.length > 1) {
      let newDate = dateArray?.length > 0 && dateArray?.sort((a: string, b: string) => (new Date(a).valueOf() - new Date(b).valueOf()));

      let finalData: any = {
        token,
        date: `${formatDate(newDate[0])},${formatDate(newDate[newDate?.length - 1])}`,
        ...(update && { user_id: reEstimateDataList?.user_id })
      };
      dispatchGetSchedulingBandWidthAction(finalData);
    }
    else if (dateArray?.length == 1) {
      let finalData: any = {
        token,
        date: `${formatDate(dateArray[0])}`,
        ...(update && { user_id: reEstimateDataList?.user_id })
      };
      dispatchGetSchedulingBandWidthAction(finalData);
    }
  }



  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const checkManagerBottom = () => {
    setManagerOffset((prv: any) => prv + managerLimit);
  };



  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);
  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };
  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    const data = finacManagerList?.filter((e: any) => e?.user_id !== loginData?.user_id)
    const finalManagerData = data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""
          } `,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);



  const handleHandleDropdownChange = (e: any) => {
    setManager({
      value: e.value,
      label: e?.label,
    });
  };
  const handleChange = (data: any) => {
    setJobData(data);
  };

  const handleProgressInputChange = (value: any, i: any) => {
    setInputChange(false);
    let newDateRange = JSON.parse(JSON.stringify(dateRange))


    let inputValue = Number(value);
    if (jobData === "daily") {
      setInput(inputValue)
      setIndex(i)
    }


    if (newDateRange[i]["requestId"] && !update) {
      let newInputValue = persistDateRange[i]["progressCount"] - persistDateRange[i]["hours"];
      newDateRange[i]["progressCount"] = newInputValue + inputValue;
    }


    let checkingValidation = inputValue <= (12 - +newDateRange[i]["progressCount"])

    newDateRange[i]["hours"] = +inputValue ? +inputValue : "";


    if (checkingValidation) {
      newDateRange[i]["errorMessage"] = "";
    }

    else if (!newDateRange[i]["requestId"]) {
      newDateRange[i]["errorMessage"] = `Maximum ${+(12 - +newDateRange[i]["progressCount"])?.toFixed(2)} hours remaining for the day`
    }
    else if (newDateRange[i]["requestId"] && newDateRange[i]["progressCount"] > 12 && !update) {
      newDateRange[i]["errorMessage"] = `Error! Maximum hours for the day exceeded`
    }
    else {
      newDateRange[i]["errorMessage"] = "";
    }


    setDateRange([...newDateRange])
    setGetRestimateHours([...newDateRange])
  }



  useEffect(() => {

    if (startDate != "Invalid date" && endDate != "Invalid date" && startDate != null && endDate != null) {
      if (startDate.toDateString() === endDate.toDateString()) return;

      if (update && reEstimateDataList?.user_id) {

        let finalData = {
          token,
          date: `${formatDate(startDate)},${formatDate(endDate)}`,
          user_id: reEstimateDataList?.user_id
        };
        dispatchGetSchedulingBandWidthAction(finalData);
      }
      else {

        let finalData = {
          token,
          date: `${formatDate(startDate)},${formatDate(endDate)}`,
        };
        dispatchGetSchedulingBandWidthAction(finalData);
      }

    }

  }, [startDate, endDate, jobData])

  const handleDateChange = ([startDate, endDate]: any) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if (startDate && endDate && startDate.toDateString() === endDate.toDateString()) {
      setDateErrorMessage("Start date and end date cannot be the same.");
      return;
    } else {
      setDateErrorMessage(null);
    }

    if (startDate && endDate) {
      const range = [];
      let date = moment(startDate);

      while (date <= endDate) {
        range.push({ date: date.toDate(), progressCount: 0, hours: "" });
        date = date.clone().add(1, "day");
      }

      setDateRange([...range]);
      setGetRestimateHours([...range])
    }
    else {
      setDateRange([]);
      setGetRestimateHours([])
    }

  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
              dispatchResetUserViewSuccess();
              dispatchResetUserViewError();
              dispatchResetUserViewMessage();
              dispatchResetUserViewStatusCode();
              dispatchResetDailyHours()
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "80px" }}>
        <div className="col-md-4 p-0">
          <label
            style={{ color: "#6e7491", fontSize: "14px" }}
            className="mb-2 mt-4"
            htmlFor="User"
          >
            Select Manager
          </label>
          <div >
            <Select
              options={finalManagerList}
              value={manager}
              components={{ Option }}
              onChange={(e) => handleHandleDropdownChange(e)}
              isSearchable={true}
              isLoading={managerFetching}
              onMenuClose={() => {
                setManagerOffset(0);
              }}
              onMenuScrollToBottom={checkManagerBottom}
              onInputChange={(e) => {
                setManagerText(e);
              }}
              isDisabled={update ? true : false}
            />
          </div>
        </div>
        <div className="mt-4" style={{ marginLeft: jobData === "oneTime" ? "250px" : "" }}>
          <span style={{ color: "#6e7491", fontSize: "14px" }}>
            Job Estimate
          </span>
          {!update ? <div className="mt-2">
            <span className="mt-4">
              <RadioContainer
                optionsList={SCHEDULING_ESTIMATE_JOB_OPTIONS}
                handleSetRadioValue={handleChange}
                radioValue={jobData}
                alignment="horizontal"
              />
            </span>

          </div> : reEstimateDataList?.estimation_type === 1 ? <div>One Time</div> : <div>Daily</div>}

        </div>
        <div className="mt-5" style={{ width: jobData === "daily" ? "25%" : "0" }}>
          {jobData === "daily" ? (
            <div style={{ width: "100%" }} >
              <div className='date-picker-wraper mr-0 w-100'>
                <Label className='m-0 p-0 w-100' style={{ position: "relative" }}>
                  <ReactDatePicker
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleDateChange}
                    minDate={moment(new Date()).add(1, "days").toDate()}
                    maxDate={moment().add(9, "months").subtract(1, 'days').toDate()}
                    selectsRange
                    dateFormat="dd/MM/yyyy"
                    className='form-control'
                    placeholderText='Select Date'
                  />
                  {/* <span style={{right:'0px',zIndex:"99",top:"2px" , marginRight:'5px',position:'absolute'}}><CalenderIcon/></span> */}
                  <span className="calender-icon" style={{ right: '10px', top: "8px", cursor: 'pointer', position: "absolute" }}>
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
              <span>{dateErrorMessage && <div style={{ color: 'red', fontSize: '12px' }}>{dateErrorMessage}</div>}</span>


            </div>) : null}
        </div>

      </div>

      {jobData === "oneTime" ? (
        <div>
          <OneTimeEstimate
            handleAddEstimateData={handleAddEstimateData}
            oneTimeEstimateData={oneTimeEstimateData}
            setOneTimeEstimateData={setOneTimeEstimateData}
            persistDateRange={persistDateRange}
            oneTimeEstimateDataInput={oneTimeEstimateDataInput}
            setGetRestimateHours={setGetRestimateHours}
            update={update}
            userId={reEstimateDataList?.user_id}
            showSchedulingEstimateData={showSchedulingEstimateData}
            setInputChange={setInputChange}
            disableDate={disableDate}
            reEstimateData={reEstimateDataList}
            setJobIndex={setIndex}
            setJobInput={setInput}
            dailyHours={dailyHours}
            jobData={jobData}
            setDateArray={setDateArray}
            setPersistDateRange={setPersistDateRange}
          />
        </div>
      ) : jobData === "daily" ? (
        <div>

          <DailyEstimate
            startDate={startDate}
            endDate={endDate}
            dateRange={dateRange}
            previousHours={previousHours}
            dailyHours={dailyHours}
            handleProgressInputChange={handleProgressInputChange}
            dailyTotal={dailyTotal}
            showSchedulingEstimateData={showSchedulingEstimateData}
          // handleButtonPressed={handleButtonPressed}
          />
        </div>
      ) : null}


      <Toaster />
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  finacManagerList: state.auth.finacManagerList,
  fetching: state.scheduling.fetching,
  success: state.scheduling.success,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  message: state.scheduling.message,
  managerFetching: state.auth.managerFetching,
  token: state.auth.token,
  totalManagerCount: state.auth.totalManagerCount,
  previousHours: state.scheduling.previousHours,
  dailyHours: state.scheduling.dailyHours,
  loginData: state.auth.loginData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchAddSchedulingEstimateAction: (data: any) => {
    dispatch(AddSchedulingEstimateAction(data));
  },
  dispatchResetUserViewSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetUserViewError: () => dispatch(resetSchedulingError()),
  dispatchResetDailyHours: () => dispatch(resetDailyHours()),
  dispatchResetUserViewMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetUserViewStatusCode: () => dispatch(resetSchedulingStatusCode()),
  dispatchGetSchedulingUserViewDataAction: (data: any) =>
    dispatch(getSchedulingUserViewListAction(data)),
  dispatchGetSchedulingBandWidthAction: (data: any) => {
    dispatch(getSchedulingBandWidthAction(data));
  },
  dispatchResetSchedulingUserList: () =>
    dispatch(resetSchedulingUserViewListing()),
  dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
  dispatchResetAuthError: () => dispatch(resetAuthError())
});
export default connect(mapStateToProps, mapDispatchToProps)(JobEstimateTab);
